'use strict';
import template from './mx-select.html';
import SelectCtrl from './mx-select.controller';
import { basePickerProperties } from './mx-picker-properties';

angular.module('mx.components').directive('mxSelect', function mxSelectDirective() {
	var directive = new mx.components.FormControlBase(SelectCtrl, null, template);
	angular.extend(directive.bindToController, basePickerProperties);
	directive.bindToController.default = '=?';
	directive.bindToController.allowEmpty = '@';

	return directive;
});
